module.exports = __webpack_public_path__ + "static/media/aboutElectronic.df7f6789.svg";